import '../../startup/public-path';
import '../destination/styles/main.less';
import app from '../../startup/app';
import hydrateApp from '../../startup/hydrate-app';
import {Template} from '../../../shared/templates/refined-destination-high-level';

app(() => hydrateApp(Template));
